// React
import { Col, Input, Label, Row } from 'reactstrap';
import React, { useCallback, useEffect, useState } from 'react';

// Helpers
import { CategoryPlans } from '../../../../store/categoryPlans/action';
import { Plans } from '../../../../store/plans/action';
import { Organizations } from '../../../../store/organizations/action';
import { useDispatch, useSelector } from 'react-redux';
import { SelectInput } from '../../../../components/selectInputComponent';
import { createData } from '../../../../utils/createData';
import { convertEventSelectToTarget } from '../../../../utils/createEvent';
import { Currency } from '../../../../components/currencyInput';
import { APIClient } from '../../../../helpers/api_helper';

export const SearchGroup = ({ validation, reset }) => {
  const [plansData, setPlansData] = useState([]);

  // Reducers States
  const { categoryPlans, plans, organizations } = useSelector((state) => ({
    categoryPlans: state.CategoryPlans.categoryPlans,
    plans: state.Plans.plans,
    organizations: state.Organizations.organizations,
  }));

  const api = new APIClient();
  const dispatch = useDispatch();

  const getPlanByCategoryID = useCallback((id) => {
    api.get(`/register/plan-by-category/${id}`).then((res) => {
      setPlansData(res.data);
    });
  }, []);

  useEffect(() => {
    dispatch(CategoryPlans());
    dispatch(Plans());
    dispatch(Organizations());
  }, [dispatch]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit(e);
      }}
    >
      <Row xs={12} md={12} lg={12} className="d-flex align-items-center m-3">
        <Col xs={3} md={3} lg={3}>
          <Label for="saleAtInput" className="form-label">
            Categoria de planos
          </Label>
          <div className="search-box">
            <SelectInput
              invalid={
                !!(
                  validation.touched.categoryPlan &&
                  validation.errors.categoryPlan
                )
              }
              options={createData(categoryPlans || [])}
              placeholder="Pesquisar por Categoria de plano"
              value={validation.values.categoryPlan}
              onChange={(eventInput) => {
                validation.handleChange(
                  convertEventSelectToTarget('categoryPlan', eventInput)
                );
                getPlanByCategoryID(eventInput.value);
                validation.handleChange(
                  convertEventSelectToTarget('plan', null)
                );
                reset();
              }}
              onBlur={(eventInput) => {
                validation.handleBlur(
                  convertEventSelectToTarget('categoryPlan', eventInput)
                );
              }}
              className="form-control"
              inputId="categoryPlan"
            />
          </div>
        </Col>
        <Col xs={3} md={3} lg={3}>
          <Label for="saleAtInput" className="form-label">
            Plano
          </Label>
          <SelectInput
            isDisabled={!validation.values.categoryPlan}
            invalid={!!(validation.touched.plan && validation.errors.plan)}
            options={plansData}
            placeholder="Pesquisar por plano"
            value={validation.values.plan}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('plan', eventInput)
              );
              reset();
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('plan', eventInput)
              );
            }}
            className="form-control"
            inputId="plan"
          />
        </Col>
        <Col xs={3} md={3} lg={3}>
          <Label for="saleAtInput" className="form-label">
            Organização
          </Label>
          <SelectInput
            invalid={
              !!(
                validation.touched.organization &&
                validation.errors.organization
              )
            }
            isClearable
            options={createData(organizations || [])}
            placeholder="Pesquisar por organização"
            value={validation.values.organization}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('organization', eventInput)
              );
              reset();
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('organization', eventInput)
              );
            }}
            className="form-control"
            inputId="categoryPlan"
          />
        </Col>
        <Col md={3}>
          <div>
            <Label for="saleAtInput" className="form-label">
              Faixa de mensalidade
            </Label>
            <div className="d-flex justify-content-center align-items-center">
              <Currency
                id="firstValueOfMonthlyPayment"
                value={validation.values.firstValueOfMonthlyPayment}
                onBlur={(_, withoutMask) => {
                  validation.handleBlur(
                    convertEventSelectToTarget(
                      'firstValueOfMonthlyPayment',
                      withoutMask
                    )
                  );
                }}
                onChange={(_, withoutMask) => {
                  validation.handleChange(
                    convertEventSelectToTarget(
                      'firstValueOfMonthlyPayment',
                      withoutMask
                    )
                  );
                }}
              />

              <span className="m-2">a</span>

              <Currency
                id="secondValueOfMonthlyPayment"
                value={Number(
                  validation.values.secondValueOfMonthlyPayment || 0
                )}
                onBlur={(_, withoutMask) => {
                  validation.handleBlur(
                    convertEventSelectToTarget(
                      'secondValueOfMonthlyPayment',
                      withoutMask
                    )
                  );
                }}
                onChange={(_, withoutMask) => {
                  validation.handleChange(
                    convertEventSelectToTarget(
                      'secondValueOfMonthlyPayment',
                      withoutMask
                    )
                  );
                }}
              />
            </div>
          </div>
        </Col>
        <Col
          xs={12}
          md={12}
          lg={12}
          className="d-flex align-items-center justify-content-end mt-3"
        >
          <button
            type="submit"
            className="btn btn-primary btn-label waves-effect waves-light"
          >
            <i className="ri-search-2-line label-icon align-middle fs-16 me-2"></i>{' '}
            Pesquisar
          </button>
        </Col>
        <Input type="submit" hidden />
      </Row>
    </form>
  );
};
